import Model from 'flarum/common/Model';
export default class BlockedRegistration extends Model {
  ip() {
    return Model.attribute('ip').call(this);
  }
  email() {
    return Model.attribute('email').call(this);
  }
  username() {
    return Model.attribute('username').call(this);
  }
  sfsData() {
    return Model.attribute('sfsData').call(this);
  }
  provider() {
    return Model.attribute('provider').call(this);
  }
  providerData() {
    return Model.attribute('providerData').call(this);
  }
  attemptedAt() {
    return Model.attribute('attemptedAt', Model.transformDate).call(this);
  }
}
flarum.reg.add('fof-anti-spam', 'common/models/BlockedRegistration', BlockedRegistration);